export const group = Object.freeze({
  ADMIN: 'admin',
  AGENT: 'agent',
  PUBLIC: 'public',
} as const);
